// extracted by mini-css-extract-plugin
export var actionButton = "_wt-2";
export var card = "_wt-0";
export var disambiguationList = "_wt-3";
export var errorCard = "_wt-4";
export var row = "_wt-1";